import { gql } from '@apollo/client';

export const CREATE_CONTACT_MESSAGE = gql`
  mutation CreateContactMessage($input: CreateContactMessageInput!) {
    createContactMessage(input: $input) {
      contactMessage {
        id
      }
      errors
    }
  }
`;
